





















import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

@Component( {
    computed: mapGetters( {
        currentImage: 'imagesModule/currentImage',
        imageById: 'imagesModule/imageById'
    } )
} )
export default class BaseImage extends Vue {
    @Prop( { default: null } ) imageId!: string | null
    imageExpanded = false
    currentImage!: any
    imageById!: any

    get relatedImage() {
        if ( !this.imageId ) {
            return this.currentImage
        } else {
            return this.imageById( this.imageId )
        }
    }
}
